import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { errorHandler } from "src/app/util/errorHandler";

@Component({
  selector: "app-results-print",
  templateUrl: "./results-print.component.html",
})
export class ResultsPrintComponent implements OnInit {
  constructor(private route: ActivatedRoute, private httpClient: HttpClient, private router: Router) {}
  session = "";
  term = "";
  sessionTerms: { Session: string, Terms: { Term: number, TermString: string }[] }[] = [];
  sessions: any = [];
  terms: { Id: number, Label: string } [] = [
    {
      Id: 1,
      Label: "1st"
    },
    {
      Id: 2,
      Label: "2nd"
    },
    {
      Id: 3,
      Label: "3rd"
    },
  ];
  isMidTerm: boolean = false;
  notification: any = {};
  noContentFound: boolean = false;

  skeletonLoader = true;
  downloader: any = null;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.isMidTerm = this.route.snapshot.paramMap.get("isMidTerm") == 'true';
    console.log(this.isMidTerm);
    const baseUrl = `${environment.BASE_URL}/results/semesterSession`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        if (res.Success) {
          this.sessionTerms = res.Data;
          this.sessions = this.sessionTerms?.map(x => x.Session);
        }
        else {
          this.notification = {
            error: true,
            message:
              res.Message,
          };
        }
      },
      (err) => {
        this.skeletonLoader = false;
        this.noContentFound = err.status === 404;
        this.notification = {
          error: true,
          message:
            err?.error?.Message || "An error occurred. Please, try again",
        };
      }
    );
  }

  loadTerm() {
    this.terms = this.sessionTerms.find(x => x.Session == this.session)?.Terms.map(x => {
      return {
        Id: x.Term,
        Label: x.TermString
      }
    }) ?? []
  }

  printResult() {
    if (!this.session || !this.term) return;

    this.notification = {};
    this.downloader = {
      loading: true,
    };

    const baseUrl = `${environment.BASE_URL}/results/printResults?session=${this.session}&term=${this.term}&isMidTerm=${this.isMidTerm}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        if (res.Data == null || !res.Success) {
          this.downloader = null;
          this.notification = {
            error: true,
            message: res.Message
          }
        }
        else {
          this.downloader = {
            loading: false,
            url: "data:application/octet-stream;base64," + res.Data?.Data,
            name: res.Data?.Name
          };
        }
      },
      (err) => {
        this.downloader = null;
        this.notification = errorHandler(err);
      }
    );
  }
}
